import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";


import { Link, useNavigate } from "react-router-dom";

import { FaEye, FaEyeSlash, FaHome } from "react-icons/fa";
import { Button } from "@mui/material";
import AffordabilityWidget from "../../payments/Affordability"; 
import authService from "../../services/auth.service";
import { useDispatch } from "react-redux";

const LoginPage = () => {


      const dispatch = useDispatch();
  const [studentData, setStudentData] = useState({
    emailId: "",
    password: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setStudentData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  const isValidEmail = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g;

 const handleSubmit = async () => {
  if (studentData.emailId === "" || studentData.password === "") {
    Swal.fire({
      title: "Please fill all fields",
      icon: "error",
      showConfirmButton: true,
    });
    return;
  }

  if (!isValidEmail.test(studentData.emailId)) {
    Swal.fire({
      title: "Please enter a valid email address",
      icon: "warning",
      showConfirmButton: true,
    });
    return;
  }

  setLoading(true);
  try {
    const response = await authService.login(studentData.emailId, studentData.password);
    const Tokken = localStorage.getItem("auth_token");

    setLoading(false);

    if (Tokken) {
      Swal.fire({
        title: `${response.message}`,
        text: "Redirecting to dashboard...",
        icon: "success",
        timer: 1000,
        showConfirmButton: false,
      });
      navigate(`/student/dashboard`, { replace: true });
    } else {
      Swal.fire({
        title: `${response.message}`,
        text: "Please enter valid email and password",
        icon: "warning",
        timer: 1000,
        showConfirmButton: false,
      });
    }
    authService.getUser(dispatch);
  } catch (error) {
    setLoading(false);
    Swal.fire({
      title: "Login Failed",
      text: "Invalid email or password.",
      icon: "error",
      showConfirmButton: true,
    });
  }
};
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <>
      <div className="contain">
        {/* <PayUPayment/> */}
        <div className="login-box">
          {/* <h2>Login</h2>
    <p className="subtitle">Welcome! So good to have you back!</p> */}
          <div autoComplete="off" className="student-login-portal">
            <p className="error" />
            <div className="form-group-login-page">
              <label htmlFor="email">Email address</label>
              <input
                onChange={handleInputChange}
                value={studentData.emailId}
                name="emailId"
                type='email' 
                required
                id="emailId"
                placeholder="youremail.@domain.com"
              />
            </div>
            <div className="form-group-login-page">
              <label htmlFor="password">Password</label>
              <div className="input-wrapper">
                <input
                  onChange={handleInputChange}
                  id="password"
                  required
                  value={studentData.password}
                  name="password"
                  type={showPassword ? "text" : "password"}
                  placeholder="***********"
                />
                <div
                  onClick={togglePasswordVisibility}
                  aria-label={showPassword ? "Hide password" : "Show password"}
                  className="icon"
                >
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    {showPassword ? (
                      <>
                        <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
                        <line x1="1" y1="1" x2="23" y2="23" />
                      </>
                    ) : (
                      <>
                        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                        <circle cx="12" cy="12" r="3" />
                      </>
                    )}
                  </svg>
                </div>
              </div>
            </div>
            <Link to={"/student/forgot-password"} className="forgat-password">Forgot Password ?</Link>
            <div className="form-actions">
              <button
                onClick={() => handleSubmit()}
                type="submit"
                className="login-btn"
              >
                {loading ? <div class="loader"></div> : "Login"}
              </button>
              <div className="register-link">
                <p>Don't have an account?</p>
                <Link to="/student/register">Register here</Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LoginPage;
